var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.tags
    ? _c(
        "div",
        { staticClass: "pt-1 pb-1" },
        [
          _vm.isTagRouteEnabled
            ? _vm._l(_vm.tags, function(tag) {
                return _c(
                  "a",
                  {
                    key: tag.id,
                    staticClass: "badge mr-1",
                    class: [
                      _vm.tagAppearance,
                      _vm.marginClasses,
                      _vm.getTextColorClass(tag.color)
                    ],
                    style: [_vm.getStyles(tag), _vm.marginInlineStyles],
                    attrs: { href: _vm.getTagLink(tag) }
                  },
                  [_c("span", [_vm._v(_vm._s(tag.names.name))])]
                )
              })
            : _vm._l(_vm.tags, function(tag) {
                return _c(
                  "span",
                  {
                    key: tag.id,
                    staticClass: "badge mr-1",
                    class: [
                      _vm.tagAppearance,
                      _vm.marginClasses,
                      _vm.getTextColorClass(tag.color)
                    ],
                    style: [_vm.getStyles(tag), _vm.marginInlineStyles]
                  },
                  [_c("span", [_vm._v(_vm._s(tag.names.name))])]
                )
              })
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }